import { TRANSACTION_KINDS } from "@/app/projects/constants";

export const transactionAmountTheme = {
  [TRANSACTION_KINDS.credit]: {
    text: "text-cp-credit",
    bg: "bg-cp-credit",
  },
  [TRANSACTION_KINDS.debit]: {
    text: "text-cp-debit",
    bg: "bg-cp-debit",
  },
};
